// utility.js
export const interpretPcode = (code) => {
  if (code.length !== 4) {
    return "Invalid code. Please enter a 4-character code.";
  }

  const roleCode = code.slice(0, 2);
  const partyCode = code.slice(2, 4);

  const roles = {
    "01": "Buyer",
    "02": "Seller",
    "03": "Witness"
  };

  const parties = {
    "01": "First",
    "02": "Second",
    "03": "Third"
  };

  const role = roles[roleCode] || "Unknown Role";
  const party = parties[partyCode] || "Unknown Party";

  return `${party} ${role}`;
};
